import styled from 'styled-components';

export const NotificationContainerWrapper = styled.div`
  --toastify-toast-shadow: ${({ theme }) => theme.shadows.elevated};
  --toastify-toast-padding: 16px;

  /* stylelint-disable selector-class-pattern */
  .Toastify__toast {
    /* Not --toastify-toast-bd-radius: the library squares the corners under a
       max-width 480px media query, which only a direct rule can outweigh. */
    border-radius: ${({ theme }) => theme.border.radii.default};
    background-color: ${({ theme }) => theme.colors.primary.main};
    text-align: center;
    color: white;
  }

  .Toastify__toast--error {
    background-color: ${({ theme }) => theme.colors.danger.medium};
  }

  .Toastify__toast.hiboo-notification {
    --toastify-toast-shadow: 0 1px 2px 0 rgb(0 0 0 / 8%);
    --toastify-toast-width: 400px;

    border-radius: ${({ theme }) => theme.border.radii.default};
    background-color: ${({ theme }) => theme.colors.surface.default};
    color: ${({ theme }) => theme.colors.text.default};
    border: 1px solid ${({ theme }) => theme.colors.border.default};
  }

  .Toastify__toast-icon {
    margin-inline-end: 0;
  }
  /* stylelint-enable selector-class-pattern */
`;
